var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "22px",
    height: "14px",
    viewBox: "0 0 48 36.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eye",
    transform: "translate(-8791 -1568.929)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_108",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 108",
    width: 4,
    height: 48,
    rx: 2,
    transform: "translate(8831.819 1568.929) rotate(45)",
    fill: "#a5bfce",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "photo",
    transform: "translate(8791 1458.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3141",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 3141",
    d: "M24,116.566c6.135,0,11.327,2.8,14.6,5.143A21.931,21.931,0,0,1,45,128.2a21.94,21.94,0,0,1-6.4,6.494c-3.276,2.346-8.468,5.142-14.6,5.142s-11.327-2.8-14.6-5.142A21.939,21.939,0,0,1,3,128.2a21.941,21.941,0,0,1,6.4-6.494c3.276-2.346,8.468-5.143,14.6-5.143m0-2.909c-13.254,0-24,11.636-24,14.546s10.745,14.545,24,14.545S48,131.112,48,128.2s-10.745-14.546-24-14.546Zm0,5.818a8.727,8.727,0,1,0,8.727,8.727A8.728,8.728,0,0,0,24,119.475ZM21.65,128.2a3.692,3.692,0,1,1,3.692-3.692A3.692,3.692,0,0,1,21.65,128.2Z",
    fill: "#a5bfce"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.bd54be3b.svg";
export { ForwardRef as ReactComponent };